"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _actions = require("./actions");

var _DoiSettings = _interopRequireDefault(require("./DoiSettings"));

var _handleActions;

var initalState = new _DoiSettings.default();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchDoiSettingsActionTypes.SUCCESS, function (state, action) {
  return new _DoiSettings.default(action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateDoiSettingsActionTypes.SUCCESS, function (state, action) {
  return new _DoiSettings.default(action.payload.data);
}), _handleActions), initalState);

exports.default = _default;
module.exports = exports.default;